import { GraphQLClient } from "graphql-request";
import { Cookies } from "react-cookie";

const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT as string;

// Define endpoint URLs for different services
const endpoints: Record<string, string> = {
  user: "user",
  contact: "contact",
  wms: "wms",
  sales: "sales",
  purchase: "purchase",
  logistic: "logistic",
  general: "general",
  crm: "crm",
  manufacture: "manufacture",
};

// Define the types for query and variables
type GraphQLQuery = string;
type GraphQLVariables = Record<string, any>;

// Create a custom GraphQLClient with middleware
class GraphQLClientWithMiddleware extends GraphQLClient {
  constructor(endpoint: string) {
    super(endpoint, {
      credentials: "include",
      mode: "cors",
    });
  }

  async requestWithMiddleware(
    query: GraphQLQuery,
    variables: GraphQLVariables,
  ): Promise<any> {
    try {
      const data = await super.request(query, variables);
      //   Sentry.addBreadcrumb({
      //     category: "graphql-query",
      //     message: "GraphQL Query",
      //     data: {
      //       query,
      //       variables,
      //     },
      //   });
      //   Sentry.addBreadcrumb({
      //     category: "graphql-response",
      //     message: "GraphQL Response",
      //     data: {
      //       response: data,
      //     },
      //   });
      return data;
    } catch (error) {
      //   Sentry.captureException(error);
      //   throw error;
    }
  }
}

// Modified createGraphQLClient function with middleware
export const createGraphQLClientWithMiddleware = (
  service: string,
  includeAuthorizationHeader: boolean = true,
): GraphQLClientWithMiddleware => {
  let baseEndpoint =
    ENVIRONMENT === "development"
      ? "https://appa-htg-dev-api.npr.digital"
      : "https://appa-api.npr.digital";
  const cookies = new Cookies();
  const access_token = cookies.get("access_token");

  let endpoint = `${baseEndpoint}/${endpoints[service]}/graphql`;

  // Local BE overrides — set REACT_APP_LOCAL_BE=true in .env.local, then run:
  //   APP_PORT=3001 yarn start:dev general
  //   APP_PORT=3002 yarn start:dev sales
  // Add more overrides here if you spin up crm / wms / purchase locally too.
  if (process.env.REACT_APP_LOCAL_BE === "true") {
    const localPorts: Record<string, number> = {
      general: 3001,
      sales: 3003,
      crm: 3002,
      wms: 3004,
      purchase: 3005,
    };
    const port = localPorts[endpoints[service]];
    if (port) {
      endpoint = `http://localhost:${port}/${endpoints[service]}/graphql`;
    }
  }

  const client = new GraphQLClientWithMiddleware(endpoint);

  if (includeAuthorizationHeader) {
    client.setHeader("authorization", `Bearer ${access_token}`);
  }

  return client;
};
